export default "__VITE_ASSET__C7qhhm7Y__"